import React from "react";

import "./style.scss";

type ButtonProps = {
  variant?:
    | "primary"
    | "secondary"
    | "danger"
    | "clear"
    | "transparent"
    | "white"
    | "gray"
    | "outline-primary"
    | "success";
  className?: string;
  type?: "button" | "submit" | "reset";
  disabled?: boolean;
  loading?: boolean;
  icon?: React.ReactNode;
  children?: React.ReactNode;
  onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  id?: any;
  tabIndex?: number;
  title?: string;
};

const Button: React.FC<ButtonProps> = ({
  variant = "primary",
  className = "",
  type = "button",
  disabled = false,
  loading = false,
  icon,
  children,
  onClick,
  id,
  tabIndex,
  title,
}) => {
  const btnClass = `btn-${variant}-custom ${className}`;

  return (
    <button
      type={type}
      className={`${btnClass} custom-btn`}
      onClick={onClick}
      disabled={disabled || loading}
      id={id}
      tabIndex={tabIndex}
      title={title}
    >
      {loading ? (
        <div
          className="mr-2 inline-block h-4 w-4 animate-spin rounded-full border-2 border-solid border-current border-r-transparent"
          role="status"
        >
          <span className="sr-only">Loading...</span>
        </div>
      ) : (
        icon && <div className="mr-2">{icon}</div>
      )}
      {children}
    </button>
  );
};

export default Button;
